// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3805J","copyRight":"Footer_copyRight__1e78i"};